import * as React from "react";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { FormControl, TextField, Button } from "@mui/material";
import { Typography } from "@mui/material";
import { useState } from "react";
import { WarrantyActivationFormValues, Warranty } from "../../app/models/warranty";
import { activationFormValidation } from "../../app/Validations/CustomValidation";
import agent from "../../app/api/agent";
import { useNavigate } from "react-router-dom";

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
}));

const initialFormvalues: WarrantyActivationFormValues = {
    warrantyNo: '',
    serialNo: '',
    name: '',
    email: ''
}

const ActivationForm = () => {

    const [activationMessage, setActivationMessage] = useState<Warranty | null>(null);
    const [showMessage, setShowMessage] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    let history = useNavigate();



    const ActivationHandler = async (values: WarrantyActivationFormValues) => {
        let isResponse = false;
        setShowMessage(true);
        setIsLoading(true);
        try {
            setIsLoading(true);
            const response = await agent.warranty.activation(values);
            if (response) {
                setActivationMessage(response);
                setIsLoading(false);

                if ((response?.warrantyInfo && response?.serialNo) !== null) {
                    isResponse = true;
                }
            }

        } catch (error) {
            console.log("Error")
            setIsLoading(false);
        }
        setIsLoading(false);
        return isResponse;
    }

    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Item>
                    <Typography fontSize={16} color={!showMessage && !activationMessage?.errorMessage ? "black" : "red"}>
                        {!showMessage ? "Please fill the following form to Activate Warranty"
                            : `${activationMessage?.errorMessage ? activationMessage?.errorMessage : 'We are working on your request'}`}
                    </Typography>

                    <Formik
                        initialValues={initialFormvalues}
                        validationSchema={activationFormValidation}
                        onSubmit={async (values: WarrantyActivationFormValues, { resetForm }) => {
                            const isResponse = await ActivationHandler(values);
                            if (isResponse) {
                                resetForm();
                            }
                        }
                        }
                    >
                        {({ values, handleChange, handleBlur, isSubmitting }) => (
                            <Form>
                                <FormControl fullWidth>
                                    <Field
                                        type="text"
                                        component={TextField}
                                        id="warrantyNo"
                                        name="warrantyNo"
                                        placeholder="Warranty Number"
                                        margin="normal"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.warrantyNo}
                                        variant="outlined"
                                        disabled={isLoading}
                                    />

                                    <ErrorMessage
                                        className="error"
                                        name="warrantyNo"
                                        component="span"
                                    />
                                </FormControl>
                                <FormControl fullWidth>
                                    <Field
                                        type="text"
                                        component={TextField}
                                        id="serialNo"
                                        name="serialNo"
                                        placeholder="Serial Number"
                                        fullWidth
                                        margin="normal"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.serialNo}
                                        variant="outlined"
                                        disabled={isLoading}
                                    />
                                    <ErrorMessage className="error" name="serialNo" component="div" />
                                </FormControl>
                                <FormControl fullWidth>
                                    <Field
                                        type="text"
                                        component={TextField}
                                        id="name"
                                        name="name"
                                        placeholder="Name"
                                        fullWidth
                                        margin="normal"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.name}
                                        variant="outlined"
                                        disabled={isLoading}
                                    />
                                    <ErrorMessage className="error" name="name" component="div" />
                                </FormControl>
                                <FormControl fullWidth>
                                    <Field
                                        type="text"
                                        component={TextField}
                                        id="email"
                                        name="email"
                                        placeholder="Email"
                                        fullWidth
                                        margin="normal"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.email}
                                        variant="outlined"
                                        disabled={isLoading}
                                    />
                                    <ErrorMessage className="error" name="email" component="div" />
                                </FormControl>
                                <Button disabled={isLoading} variant="contained" type="submit">
                                    Activate Warranty
                                </Button>
                                <Button disabled={isLoading} variant="contained" type="submit" onClick={() => history('/')} sx={{ ml: 2 }}>
                                    close
                                </Button>
                            </Form>
                        )}
                    </Formik>
                </Item>
            </Grid>
        </Grid >
    )
}

export default ActivationForm